import { Crop, PixelCrop } from 'react-image-crop';
import _ from 'lodash';
import { action, makeObservable, observable, reaction } from 'mobx';
import { clearImagePreview, createImagePreview } from './image-preview';

export class ImageUploaderStore {
  scale = 1;
  rotate = 0;
  aspect = 1;
  zoom = 1;
  dragActive = false;
  value?: string;
  disabled!: boolean;
  crop = {} as Crop;
  previewSrc?: string;
  imgSrc?: string;
  completedCrop = {} as PixelCrop;
  imageRef: any;
  croppedImage: any;

  constructor(config: any, imageRef: any, value?: string, disabled = false) {
    makeObservable(this, {
      scale: observable,
      rotate: observable,
      aspect: observable,
      zoom: observable,
      dragActive: observable,
      value: observable,
      disabled: observable,
      crop: observable,
      previewSrc: observable,
      imgSrc: observable,
      completedCrop: observable,
      croppedImage: observable,
      changeDragActive: action,
      changeZoom: action,
      changeCrop: action,
      changePreviewSrc: action,
      changeImgSrc: action,
      changeCompletedCrop: action,
      changeImageRef: action,
      reset: action,
      changeCroppedImage: action,
    });

    this.scale = config.scale || 1;
    this.rotate = config.rotate || 0;
    this.aspect = config.aspect || 1;
    this.previewSrc = this.imgSrc = this.value = value || '';
    this.disabled = disabled;
    this.imageRef = imageRef;

    reaction(
      () => this.completedCrop,
      _.debounce(crop => {
        if (!crop?.width || crop?.width < 10) {
          return;
        }
        createImagePreview(
          this.imageRef,
          crop,
          this.scale,
          this.rotate
        ).then((url: string) => {
          this.changePreviewSrc(url);
        });
      }, 200)
    )
  }

  changeDragActive(active: boolean) {
    this.dragActive = active;
  }

  changeCrop(crop: Crop) {
    if (crop?.width > 50 && crop?.height > 50) {
      this.crop = crop;
    }
  }

  changePreviewSrc(image: string) {
    this.previewSrc = image;
  }

  changeZoom(zoom: number) {
    this.zoom = zoom;
  }

  changeImgSrc(image: string) {
    this.imgSrc = image;
  }

  changeCompletedCrop(image: string) {
    this.changeCroppedImage(image)
  }

  changeImageRef(imageRef: HTMLImageElement) {
    this.imageRef = imageRef;
  }

  changeCroppedImage(image: string) {
    this.croppedImage = image;
  }

  reset() {
    clearImagePreview()
    this.imgSrc = undefined;
    this.previewSrc = undefined;
    this.completedCrop = {} as PixelCrop;
    this.crop = {} as Crop;
    this.dragActive = false;
  }
}